export const environment = {
  name: 'DEV',
  production: false,
  // apiUrl: 'https://back.dev.growthroad.es',
  // boUrl: 'https://office.dev.growthroad.es',
  // appUrl: 'https://dev.growthroad.es',
  apiUrl: 'https://backend.develop.growthroad.es',
  boUrl: 'https://backoffice.develop.growthroad.es',
  appUrl: 'https://app.dev.noliaedu.com',
  /** Header `x-client-platform`: aísla el login de B2C del front escolar. */
  clientPlatform: 'b2c-platform',
  recaptcha: {
    siteKey: '6LcY1xsgAAAAAGgTMBARSx_KrF2vSfi2K0JsZe25',
  }
};
